import Vue from 'vue';
import Vuex from 'vuex';

import ModalApi from '@/services/modal.api';

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    userLoggedIn: false,
    snack: '',
    regionNotSelected: false,
    expandedDashboard: true,
    pageCanHaveExpandedDashboard: false,
    machineSortType: 3
  },
  mutations: {
    setSnack(state, snack) {
      state.snack = snack;
    },
    setRegionsNotSelected(state, bool) {
      state.regionNotSelected = bool;
    },
    toggleExpandedDashboard(state) {
      state.expandedDashboard = !state.expandedDashboard;
    },
    setPageHaveExpandedDashboard(state, data) {
      state.pageCanHaveExpandedDashboard = data;
    },
    setUserLoginState(state, logged) {
      state.userLoggedIn = logged;
    },
    setMachineSortType(state, type) {
      state.machineSortType = type;
    }
  },
  actions: {
    setSnackAction({ commit }, snack) {
      commit('setSnack', snack);
    },
    sendFeedback({}, data) {
      let modalApi = new ModalApi();
      return new Promise((resolve, reject) => {
        modalApi
          .sendFeedback(data)
          .then(result => {
            resolve(result);
          })
          .catch(error => {
            console.error('Error occured sendFeedback: ' + error);
            reject(error);
          });
      });
    },
    contactSupport({}, data) {
      let modalApi = new ModalApi();
      return new Promise((resolve, reject) => {
        modalApi
          .contactSupport(data)
          .then(result => {
            resolve(result);
          })
          .catch(error => {
            console.error('Error occuredcontactSupport: ' + error);
            reject(error);
          });
      });
    },
    logInUser({ commit }) {
      commit('setUserLoginState', true);
    },
    logOutUser({ commit }) {
      commit('setUserLoginState', false);
    }
  },
  getters: {
    getExpdandedDashboardValue: state => {
      return state.expandedDashboard && state.pageCanHaveExpandedDashboard;
    },
    getUserLogged: state => {
      return state.userLoggedIn;
    },
    getRegionNotSelected: state => {
      return state.regionNotSelected;
    },
    getMachineSortType: state => {
      return state.machineSortType;
    }
  }
});

export default store;
